import { render, staticRenderFns } from "./BuddyBotParams.vue?vue&type=template&id=7a42e790&scoped=true"
import script from "./BuddyBotParams.vue?vue&type=script&lang=js"
export * from "./BuddyBotParams.vue?vue&type=script&lang=js"
import style0 from "./BuddyBotParams.vue?vue&type=style&index=0&id=7a42e790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a42e790",
  null
  
)

export default component.exports